<template>
  <div class="task-list">
    <loading-box v-bind:loading="loading"></loading-box>
    <div class="filter-bar">
      <div class="green-label">Filters</div>
      <search-filters
        :filters="filters"
        @change="changeFilter"
        @press-enter="applyFilter"
        ref="searchFilters"
      ></search-filters>
      <div>
        <b-button
          @click="applyFilter">Apply</b-button>
        <b-button
          @click="resetFilters">Reset</b-button>
      </div>

    </div>
    <div class="green-divider"></div>
    <!--    Bootstrap Table-->
    <b-table striped hover :items="taskList" :fields="taskFields" select-mode="single" selected-variant="success"
             th-class="bv-table-header" :current-page="currentPage" :per-page="perPage"
             :filter="filterMethod === 'local' ? filter : undefined"
             :filterIncludedFields="filterFields"
             class="bv-table">
      <!--Activated Checkbox Row Element-->
      <template v-slot:cell(published)="row">
        <b-form-checkbox v-model="row.item.published" v-on:change="togglePublish(row.item, $event)"></b-form-checkbox>
      </template>
      <!--User Actions Row Element-->
      <template v-slot:cell(actions)="row">
        <i class="row-icon-button row-action" :class="$config.icons.general.edit" @click="taskActionEdit(row.item)" v-b-tooltip.hover title="Edit Product"></i>
        <i class="fa fa-times-circle row-icon-button-danger row-action ml-3" v-b-tooltip.hover title="Does nothing!"
           @click="userActionDelete(row.item)"></i>
      </template>
    </b-table>
    <div class="green-divider"></div>
        <div class="footer">
          <div class="table-results">
            Results: {{totalRows}}
          </div>
          <div class="page-bar">
            <b-form-select
              variant="dark"
              v-model="perPage"
              id="perPageSelect"
              size="sm"
              :options="pageOptions"
              class="page-select">
            </b-form-select>
            <b-pagination
              variant="dark"
              v-model="currentPage"
              :total-rows="taskList.length"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="page-buttons"></b-pagination>
          </div>
        </div>
    <!--   Product Edit Modal Template-->
    <b-modal id="modal-edit-task" centered class="modal-content" size="xl" title="Edit Task" no-close-on-backdrop hide-footer>
      <AdminEditTask :task="currentTask"></AdminEditTask>
      <b-button @click="$bvModal.hide('modal-edit-task')" class="button btn">Close</b-button>
    </b-modal>
  </div>
</template>

<script>
import LoadingBox from '../helpers/LoadingBox'

import * as DataProvider from '../helpers/DataProvider'
import * as ErrorHelper from '../helpers/ErrorHelper'
import moment from 'moment'
import * as AlertHelper from '../helpers/AlertHelper'
import {adminGetTasks} from '../helpers/DataProvider'
import AdminEditTask from '@/components/admin/AdminEditTask.vue'
import SearchFilters from '@/components/shared/SearchFilters.vue'
export default {
  name: 'admin-task-list',
  components: {
    SearchFilters,
    AdminEditTask,
    LoadingBox
  },
  props: {
    products: Array
  },
  data: function () {
    return {
      loading: true,
      filterMethod: 'local', // Filter Locally or remotely at the server-side
      filter: '',
      filterFields: null,
      currentTask: null,
      // Table Pagination
      currentPage: 1,
      totalRows: 0,
      perPage: 10,
      pageOptions: [
        { value: 10, text: '10' },
        { value: 25, text: '25' },
        { value: 50, text: '50' },
        { value: 0, text: 'All' }
      ],
      taskFields: [
        { key: 'id',
          label: 'Id',
          sortable: true
        },
        { key: 'status',
          label: 'Status',
          sortable: true
        },
        { key: 'created',
          label: 'Created',
          sortable: true
        },
        { key: 'expiry',
          label: 'Expiry',
          sortable: true
        },
        { key: 'owner_email',
          label: 'Owner',
          sortable: true
        },
        { key: 'last_update',
          label: 'Updated',
          sortable: true,
          formatter: this.formatTimestamp
        },
        { key: 'actions',
          label: 'Actions'
        }
      ],
      filters: [
            {
            label: 'Filter By Status',
            type: 'select',
            placeholder: 'Status...',
            fieldName: 'status',
            options: [
              { value: 'COMPLETE', text: 'Complete' },
              { value: 'FAILED', text: 'Failed' },
              { value: 'INPROG', text: 'In Progress' },
              { value: 'QUEUED', text: 'Queued' },
              { value: 'NEW', text: 'New' }
            ]
          },
          {
            label: 'Filter By Owner',
            type: 'string',
            placeholder: 'Owner Email',
            fieldName: 'owner_email'
          }
        ],
      currentFilter: {},
      taskList: []
    }
  },
  async created () {
    if (this.tasks) {
      this.taskList = this.tasks
    } else {
      await this.refresh()
    }
    this.loading = false
  },
  methods: {
    applyFilter: function () {
      this.refresh()
    },
    changeFilter: function (filters) {
      console.log('Set Filters: ', filters)
      this.currentFilter = filters
    },
    resetFilters: function () {
      this.$refs.searchFilters.reset()
      this.refresh()
    },
    refresh: async function () {
      let resp = await DataProvider.adminGetTasks()
      if (resp.success) {
        let tasks = resp.data.tasks.reverse()
        // Apply filters locally, we might add them to the API later if needed
        if (Object.hasOwn(this.currentFilter, 'status')) {
          tasks = tasks.filter(t => t.status === this.currentFilter.status)
        }
        if (Object.hasOwn(this.currentFilter, 'owner_email')) {
          this.filterFields = ['owner_email']
          this.filter = this.currentFilter.owner_email
        } else {
          this.filterFields = []
          this.filter = ''
        }
        this.taskList = tasks
        this.totalRows = tasks.length
      } else {
        ErrorHelper.displayDataErrorToast(resp)
      }
    },
    formatTimestamp: function (timestamp) {
      return moment.utc(timestamp).local().format('YYYY-MM-DD HH:mm')
    },
    // togglePublish: async function (item, event) {
    //   console.log(event)
    //   let resp = await DataProvider.adminGetTasks()
    //   console.log(resp)
    //   if (resp.success) {
    //     AlertHelper.successToast('Product Publish Property Updated', 'Update Successful')
    //   } else {
    //     ErrorHelper.displayDataErrorToast(resp)
    //   }
    // },
    taskActionEdit: function (task) {
      this.currentTask = task
      this.$bvModal.show('modal-edit-task')
    },
    onSave: async function () {
      this.refresh()
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../../variables';

  .task-list{
    position: relative;
  }

  .filter-bar {
    display: flex;
    flex-direction: row;
    align-content: center;
  }

  .page-bar {
    display: flex;
    flex-direction: row;
  }

  .page-select {
    width: 10%;
    min-width: 50px;
  }

  .page-buttons {
    width: 25%;
    min-width: 150px;
  }

  .row-action {
    font-size: 1.5rem;
    margin-right: 0.5rem;
  }

  .child-card {
    background: $theme-color-background-4;
    padding: 10px 20px;
    border: 2px solid $theme-color-primary-3;
  }

  .advanced-filter{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 5px;
    padding: 3px;
    background: $theme-color-background-1;
    border: 1px solid $theme-color-primary-3;
  }

  .filter-label {
    font-family: 'Open Sans', sans-serif;
    color: $theme-color-primary-3;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 1px;
    margin: 0px 5px;
  }

  .sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
    height: calc(1.5em + 0.5rem + 2px);
  }

  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 5px 20px;
  }

  .table-results {
    color: $theme-color-primary-4;
    font-weight: 600;
  }
</style>
